import { Icon, Text } from '@lightspeed/design-system-react'
import { useT } from '@transifex/react'
import { reactular } from '@vendhq/reactular'
import React from 'react'

interface Props {
  shouldShowFulfilmentBanner: boolean
  isUnfulfilledPickUp?: boolean
}

export const SaleFulfilmentBanner: React.FC<Props> = ({
  shouldShowFulfilmentBanner,
  isUnfulfilledPickUp,
}) => {
  const t = useT()

  const fulfilmentType = isUnfulfilledPickUp ? 'picked up' : 'delivered'

  return (
    shouldShowFulfilmentBanner && (
      <div
        className="vd-banner vd-banner--info sale-banner"
        data-testid="sale-fulfilment-banner"
      >
        <Text type="supplementary">
          <Icon icon="circle-o" className="vd-mr1"></Icon>
          {t(`Unfulfilled sale. This order will be ${fulfilmentType}.`, {
            _context: 'Sale fulfilment banner',
          })}
        </Text>
      </div>
    )
  )
}

export const ReactSaleFulfilmentBannerComponent = reactular(
  SaleFulfilmentBanner,
  ['shouldShowFulfilmentBanner', 'isUnfulfilledPickUp'],
  'reactWrapper'
)
